import { createAsyncThunk } from '@reduxjs/toolkit';
import { authFetch } from '../../Utils/authFetch';
import { REPORTS } from '../../constant';

type Payload = {
  studyInstanceUID?: string;
  reportId?: string;
};

// Fetch the CardioSoft stress values parsed from the study's attached XML.
// Returns { isStress, fields, meta }. isStress=false when no stress XML is
// attached (non-stress study or nothing uploaded yet) — the caller then simply
// doesn't inject any stress values.
export const getStressValues = createAsyncThunk(
  'getStressValues',
  async (payload: Payload, { rejectWithValue }) => {
    try {
      const qs = payload?.studyInstanceUID
        ? `studyInstanceUID=${encodeURIComponent(payload.studyInstanceUID)}`
        : `reportId=${encodeURIComponent(payload?.reportId || '')}`;
      const response = await authFetch(`${REPORTS.GET_STRESS_VALUES}?${qs}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        return rejectWithValue(errorData.message || 'Failed to fetch stress values');
      }
      return await response.json();
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
